/* Polsk katalog for locale-inbox-vouchers-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'voucher.none': 'Brak dowodów',
  'voucher.noLedgerLines': 'Brak jeszcze pozycji księgi głównej z backendu.',
  'voucher.noLedger': 'Brak pozycji księgi głównej',
  'voucher.action': 'Działanie',
  'voucher.title': 'Transakcje',
  'voucher.incompleteBasis': 'Pokrycie dziennika jest niepełne. Listy można używać do wyszukiwania dokumentów, ale nie należy jej traktować jako kompletnej księgi głównej ani listy dowodów.',
  'voucher.subtitle': 'Wszystkie zaksięgowane transakcje roku obrotowego',
  'voucher.backToVat': 'Wróć do MVA-melding',
  'voucher.showAll': 'Pokaż wszystkie transakcje',
  'voucher.download': 'Pobierz',
  'voucher.loadingPreview': 'Wczytywanie podglądu...',
  'voucher.cannotPreviewUse': 'Nie można wyświetlić podglądu pliku. Użyj „Pobierz”, aby go otworzyć.',
  'voucher.cannotPreview': 'Dla tego typu pliku podgląd jest niedostępny.',
  'voucher.invoice': 'Faktura',
  'voucher.voucher': 'Dowód księgowy',
  'voucher.attachmentAttached': 'Dowód załączony',
  'voucher.commentOptional': 'Komentarz (opcjonalnie)',
  'voucher.commentPh': 'Np. błędna kwota, podwójne księgowanie lub zły dostawca.',
  'voucher.view': 'Widok',
  'voucher.viewHelp': 'Przełączaj między listą dowodów, szczegółowymi księgowaniami i księgą główną pogrupowaną według kont.',
  'voucher.view.bilag': 'Dowody',
  'voucher.view.detaljer': 'Szczegóły',
  'voucher.view.hovedbok': 'Księga główna',
  'voucher.searchPh': 'Szukaj po dowodzie, koncie lub kwocie',
  'voucher.searchHelp': 'Szukaj po numerze dowodu, kontrahencie, koncie/księgowaniu lub kwocie. W księdze głównej możesz też szukać po Wn, Ma i saldzie.',
  'voucher.filterHelp': 'Filtruj dowody według typu, załącznika, statusu płatności, okresu i kwoty.',
  'voucher.amountTitle': 'Kwota na dowodzie',
  'voucher.amountHelp': 'Netto to kwota bez VAT (sam koszt/przychód), VAT to podatek, a brutto to kwota łączna z VAT. Razem z datą i numerem dowodu są to kluczowe informacje księgowania.',
  'voucher.rowHelp': 'Każdy wiersz to jeden dowód. Ikona i etykieta pokazują typ (sprzedaż, zakup, faktura od dostawcy, faktura korygująca, dowód ręczny), a obok widzisz nazwę i numer dowodu. Stuknij wiersz, aby otworzyć dowód.',
  'voucher.net': 'Netto',
  'voucher.netHelp': 'Kwota bez VAT - sam koszt lub przychód księgowany na koncie.',
  'voucher.vat': 'VAT',
  'voucher.vatHelp': 'Podatek VAT na dowodzie - VAT należny przy sprzedaży, VAT naliczony (do odliczenia) przy zakupach.',
  'voucher.gross': 'Brutto',
  'voucher.grossHelp': 'Kwota łączna z VAT - netto plus VAT. To kwota faktycznie zapłacona lub otrzymana.',
  'voucher.accountPh': 'Np. oprogramowanie, bank lub 6300',
  'voucher.account': 'Konto',
  'voucher.accountHelp': 'Konto mówi, czego dotyczy księgowanie - pochodzi z planu kont. Numer konta decyduje, gdzie kwota trafi w księgach (1xxx aktywa, 2xxx zobowiązania/kapitał własny, 3xxx przychody, 4-7xxx koszty). Stuknij ikonę listy, aby przeszukać plan kont.',
  'voucher.pickAccount': 'Wybierz konto',
  'voucher.searchChart': 'Szukaj w planie kont...',
  'voucher.noDescription': 'Bez opisu',
  'voucher.removeEntry': 'Usuń księgowanie',
  'voucher.entryDate': 'Data dowodu',
  'voucher.entryDateHelp': 'Data, z jaką księgowanie ma zostać zaksięgowane. Decyduje o tym, do którego okresu księgowego i okresu VAT trafi księgowanie.',
  'voucher.whatFor': 'Czego dotyczy księgowanie?',
  'voucher.whatForHelp': 'Krótki tekst wyjaśniający, czego dotyczy księgowanie. Wyświetla się w księdze głównej i ułatwia późniejsze zrozumienie księgowania.',
  'voucher.fromAccount': 'Z konta',
  'voucher.toAccount': 'Na konto',
  'voucher.fromAccountCredit': 'Z konta (Ma)',
  'voucher.fromAccountHelp': 'Konto, Z KTÓREGO wychodzą pieniądze - strona Ma księgowania. Jeśli np. płacisz czynsz z rachunku bankowego, bank (1920) to „Z”. Zapis po stronie Ma zmniejsza aktywo lub zwiększa zobowiązanie/przychód.',
  'voucher.vatCode': 'Kod VAT',
  'voucher.vatCodeHelp': 'Kod podatkowy określa, jak VAT jest obliczany i wykazywany w MVA-melding. Kod 86 stosuje się do usług świadczonych na odległość z zagranicy. Import towarów rejestruje się przez zgłoszenie celne.',
  'voucher.swap': 'Zamień Z i Na',
  'voucher.swapHelp': 'Zamienia konta Z i Na w pozycji. Przydatne, jeśli Wn i Ma zostały wpisane odwrotnie.',
  'voucher.toAccountDebit': 'Na konto (Wn)',
  'voucher.toAccountHelp': 'Konto, NA KTÓRE trafiają pieniądze - strona Wn księgowania. Jeśli księgowanie dotyczy czynszu, konto czynszu (6300) to „Na”. Zapis po stronie Wn zwiększa koszt lub aktywo.',
  'voucher.addLineHelp': 'Dodaje nową pozycję do tego księgowania. Używaj kilku pozycji, gdy kwota ma zostać rozdzielona na kilka kont - wszystkie pozycje razem muszą zbilansować Wn i Ma do zera.',
  'voucher.attachHelp': 'Załącz dokumentację do księgowania - paragon, fakturę lub inny dowód. Opcjonalne, ale zalecane: dobra dokumentacja sprawia, że księgi są weryfikowalne. Możesz przeciągnąć pliki lub wkleić zrzut ekranu.',
  'voucher.attachOptional': 'Załączniki (opcjonalnie)',
  'voucher.uploadAttachment': 'Prześlij załącznik',
  'voucher.deleteAttachment': 'Usuń załącznik',
  'voucher.openNewTab': 'Otwórz w nowej karcie',
  'voucher.balance': 'Bilans',
  'voucher.balanceHelp': 'Pokazuje, czy księgowanie się bilansuje. „Zbilansowane” oznacza, że suma Na (Wn) równa się sumie Z (Ma) - wtedy księgowanie można zarejestrować. Jeśli jest różnica, popraw kwoty tak, aby bilansowały się do zera.',
  'voucher.toDebit': 'Na (Wn)',
  'voucher.fromCredit': 'Z (Ma)',
  'voucher.posted': 'Zaksięgowano',
  'voucher.edit': 'Edytuj',
  'voucher.newCopy': 'Nowa kopia księgowania swobodnego',
  'voucher.newFree': 'Nowe księgowanie swobodne',
  'voucher.from': 'Z',
  'voucher.to': 'Na',
  'voucher.sum': 'Suma',
  'voucher.newEntry': 'Nowe księgowanie',
  'voucher.newEntryHelp': 'Dodaje kolejne księgowanie (nowy dowód) w ramach tej samej rejestracji. Każde księgowanie ma własną datę, opis i pozycje i jest księgowane jako osobny dowód.',
  'voucher.postHelp': 'Księguje księgowanie(-a) w księgach. Przycisk staje się aktywny dopiero, gdy wszystkie księgowania są zbilansowane - czyli Wn i Ma dają zero.',
  'voucher.details': 'Szczegóły',
  'voucher.statusBalanced': 'Zbilansowane',
  'voucher.statusMissingAccount': 'Brak konta',
  'voucher.statusSameAccount': 'To samo konto',
  'voucher.statusEmpty': 'Puste',
  'voucher.statusUnbalanced': 'Niezbilansowane',
  'voucher.attachDropHint': 'Przeciągnij i upuść pliki tutaj lub wklej zrzut ekranu za pomocą Ctrl+V',
  'voucher.chooseBothAccounts': 'Wybierz konto Z i konto Na.',
  'voucher.sameAccountWarning': 'Konto Z i konto Na nie mogą być tym samym kontem.',
  'voucher.balancedReady': 'Zbilansowane - gotowe do zarejestrowania',
  'voucher.enterAmount': 'Wpisz kwotę.',
  'voucher.difference': 'Różnica: {amount}',
  'voucher.postedTitlePlural': 'Księgowania zarejestrowane',
  'voucher.postedTitleSingular': 'Księgowanie zarejestrowane',
  'voucher.postedBodyPlural': 'Zaksięgowane księgowania: {count}.',
  'voucher.postedBodySingular': 'Księgowanie zostało zaksięgowane.',
  'voucher.postedIntro': 'Tak zostało zaksięgowane:',
  'voucher.descriptionRequired': 'Wpisz opis we wszystkich księgowaniach, zanim zaksięgujesz.',
  'voucher.saveFailed': 'Nie udało się zarejestrować księgowania.',
  'voucher.backTo': 'Wróć do: {label}',
  'voucher.controlPoint': 'punkt kontrolny',
  'voucher.editTitle': 'Edytuj księgowanie swobodne',
  'voucher.freePosting': 'Księgowanie swobodne',
  'voucher.editSubtitle': 'Zaktualizuj księgowanie i zapisz zmiany w backendzie.',
  'voucher.correctPostedTitle': 'Skoryguj zaksięgowany dowód',
  'voucher.correctPostedSubtitle': 'Oryginał zostaje zachowany. Plumme księguje storno i nowy dowód zastępczy w jednej operacji.',
  'voucher.correctPostedNotice': 'Pierwotny dowód księgowy i numer dziennika nie ulegają zmianie. Zmiana zostaje zapisana jako powiązane storno i zastąpienie.',
  'voucher.correctionReason': 'Przyczyna korekty',
  'voucher.correctionReasonPlaceholder': 'Opisz, co było błędne i dlaczego dowód księgowy jest korygowany',
  'voucher.correctPostedAction': 'Skoryguj dowód księgowy',
  'voucher.correctionPreview': 'Podgląd korekty',
  'voucher.correctionOriginal': 'Oryginał',
  'voucher.correctionReversal': 'Dokładne storno',
  'voucher.correctionReplacement': 'Dowód zastępczy',
  'voucher.freePostingSubtitle': 'Księgowania ręczne - Wn i Ma muszą bilansować się do zera',
  'voucher.freePostingTitleHelp': 'Księgowanie ręczne pozwala księgować bezpośrednio na koncie, gdy potrzebujesz pełnej kontroli - na przykład przy korektach, przeksięgowaniach lub zapisach, które nie pasują do zwykłego zakupu ani sprzedaży. Sam decydujesz, między którymi kontami przenoszona jest kwota.',
  'voucher.directVatWarningTitle': 'Ostrzeżenie: bezpośrednie księgowanie na koncie VAT',
  'voucher.directVatWarningBody': 'Te księgowania trafią do księgi głównej, ale nie zostaną ujęte w MVA-melding. Użyj zwykłego zakupu, sprzedaży lub zgłoszenia celnego, gdy kwota ma być wykazana jako VAT.',
  'voucher.directVatExcluded': 'nieujęte w MVA-melding',
  'voucher.directVatConfirmLabel': 'Wpisz OK, aby potwierdzić, że rozumiesz konsekwencje',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Zarejestruj zapisy',
  'voucher.registerEntrySingular': 'Zarejestruj zapis',
  'voucher.registering': 'Rejestrowanie...',
  'voucher.creditWord': 'Ma',
  'voucher.debitWord': 'Wn',
  'voucher.attachmentFallbackName': 'zalacznik',
  'inbox.prevPage': 'Poprzednia strona',
  'inbox.page': 'Strona',
  'inbox.nextPage': 'Następna strona',
  'inbox.zoomOut': 'Pomniejsz',
  'inbox.zoomIn': 'Powiększ',
  'inbox.rotate': 'Obróć dokument',
  'inbox.mainDoc': 'Dokument główny',
  'inbox.moveTo': 'Przenieś do',
  'inbox.payOperating': 'Rachunek bieżący - 1920',
  'inbox.payCash': 'Gotówka - 1900',
  'inbox.payPrivate': 'Wydatek prywatny',
  'inbox.payUnknown': 'Wybierz źródło płatności ...',
  'inbox.suggestion': 'Propozycja od SuperPlumma',
  'inbox.docType': 'Typ dokumentu',
  'inbox.quickChoices': 'Szybki wybór',
  'inbox.quickChoiceUse': 'Wybierz, co ma zastąpić szybki wybór',
  'inbox.quickChoiceRemembered': 'Zapamiętane z wcześniejszych dokumentów tego dostawcy (liczba: {count}).',
  'inbox.quickChoiceAccount': 'Zastąp konto',
  'inbox.quickChoiceDescription': 'Zastąp opis',
  'inbox.quickChoiceBoth': 'Zastąp oba',
  'inbox.purchase': 'Zakup',
  'inbox.supplierInvoice': 'Faktura dostawcy',
  'inbox.pickSupplier': 'Wybierz dostawcę',
  'inbox.invoiceNoPh': 'Np. 0012345',
  'inbox.toggleVatHelp': 'Kliknij, aby przełączyć, czy wpisywana kwota jest bez VAT, czy z VAT. Plumme automatycznie przelicza i zapisuje kwotę brutto w propozycji dokumentu.',
  'inbox.vatDeductionRate': 'Proponowane odliczenie VAT',
  'inbox.documentVatRateHint': 'Dokument wykazuje {documentRate} % VAT. Propozycja stosuje {deductionRate} % odliczenia na podstawie statusu VAT firmy i wybranego traktowania.',
  'inbox.accountCategory': 'Konto/kategoria',
  'inbox.accountHelp': 'Propozycja SuperPlumma jest wstępnie wybrana. Kliknij, aby wybrać inne konto.',
  'inbox.dueDateFromReceipt': 'Dokument nie ma terminu płatności. Ustawiono datę dokumentu.',
  'inbox.supplierNotSaved': 'Wybierz zapisanego dostawcę lub zapisz dostawcę przed zaksięgowaniem faktury.',
  'err.purchase.supplierNotSaved': 'Wybierz zapisanego dostawcę lub zapisz dostawcę przed zaksięgowaniem faktury.',
  'inbox.duplicateTitle': 'Możliwe podwójne księgowanie',
  'inbox.duplicateBody': 'Dokument z tą samą datą i kwotą został już zaksięgowany.',
  'inbox.duplicateSameSupplier': 'Dokument z tą samą datą, kwotą i dostawcą został już zaksięgowany.',
  'inbox.duplicateUploadFile': 'Możliwe podwójne przesłanie: dokładnie ten sam plik jest już w skrzynce odbiorczej.',
  'inbox.duplicateUploadContent': 'Możliwe podwójne przesłanie: ten sam dostawca i kwota co w innym dokumencie w skrzynce odbiorczej, a daty dokumentów mieszczą się w 7 dniach.',
  'inbox.duplicateUploadCount': 'Dotyczy innych dokumentów (liczba: {count}).',
  'inbox.setPaymentSource': 'Zapłacono z',
  'inbox.bulkPaymentTitle': 'Zapłacono z',
  'inbox.bulkPaymentLead': 'Źródło zostanie ustawione dla wybranych dokumentów (liczba: {count}). Później możesz je zmienić w każdym dokumencie osobno.',
  'inbox.bulkPaymentLabel': 'Zapłacono z',
  'inbox.bulkPaymentHint': 'Dokumenty będą gotowe do zaksięgowania z tym kontem.',
  'inbox.bulkPaymentPick': 'Najpierw wybierz źródło płatności.',
  'inbox.bulkPaymentConfirm': 'Ustaw dla dokumentów ({count})',
  'inbox.bulkPaymentDone': 'Ustawiono źródło płatności dla dokumentów (liczba: {count}).',
  'inbox.uploadPaymentSingleTitle': 'Zapłacono z',
  'inbox.uploadPaymentBulkTitle': 'Przypisz źródła płatności',
  'inbox.uploadPaymentAppliesTo': 'Dotyczy wybranych dokumentów (liczba: {count})',
  'inbox.uploadPaymentSelectFirst': 'Zaznacz dokumenty poniżej, a przyciski ustawią dla nich źródło płatności.',
  'inbox.uploadPaymentBank': 'Bank',
  'inbox.uploadPaymentBankSetup': 'Najpierw dodaj rachunek bankowy',
  'inbox.uploadPaymentOtherSource': 'Wybierz inne źródło płatności ...',
  'inbox.uploadPaymentOperating': 'Rachunek bieżący',
  'inbox.uploadPaymentPrivate': 'Prywatne',
  'inbox.uploadPaymentPrivateRecommended': 'Zalecane bez rachunku firmowego',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analizuje',
  'inbox.collectionNotice': 'Wezwanie windykacyjne',
  'inbox.collectionNoticeTitle': 'To należy do dokumentu pierwotnego',
  'inbox.collectionNoticeBody': 'Należności głównej nie księguj ani nie ujmuj w VAT ponownie. Powiąż wezwanie z dokumentem pierwotnym; odsetki i koszty windykacji rozlicz osobno bez VAT.',
  'inbox.collectionNoticePrincipal': 'Należność główna',
  'inbox.collectionNoticeInterest': 'Odsetki',
  'inbox.collectionNoticeCosts': 'Koszty windykacji',
  'inbox.collectionNoticeCandidates': 'Możliwe dokumenty pierwotne',
  'inbox.collectionNoticeLink': 'Powiąż',
  'inbox.collectionNoticeLinked': 'Wezwanie windykacyjne zostało powiązane z dokumentem pierwotnym.',
  'inbox.collectionNoticeLinkFailed': 'Nie udało się powiązać wezwania windykacyjnego z dokumentem pierwotnym.',
  'inbox.collectionNoticeOpenOriginal': 'Otwórz dokument pierwotny',
  'inbox.collectionNoticeNoCandidate': 'Nie znaleziono pewnego dopasowania. Znajdź lub prześlij pierwotną fakturę przed obsłużeniem wezwania.',
  'inbox.collectionNoticeBookBlocked': 'Przed obsłużeniem powiąż z dokumentem pierwotnym',
  'inbox.uploadPaymentAssigned': 'Konto {account}',
  'inbox.uploadPaymentUnpaid': 'Jeszcze niezapłacone',
  'inbox.uploadPaymentUnpaidHint': 'Dla faktury dostawcy, która ma pozostać zobowiązaniem do czasu zapłaty.',
  'inbox.uploadPaymentAnalyze': 'Pozwól Plumme znaleźć źródło płatności',
  'inbox.uploadPaymentUnassigned': 'Nieprzypisane',
  'inbox.uploadPaymentSelectVisible': 'Zaznacz widoczne',
  'inbox.uploadPaymentShowAll': 'Pokaż wszystkie',
  'inbox.uploadPaymentShowPending': 'Pokaż tylko nieprzypisane',
  'inbox.uploadPaymentProgress': 'Przypisano {completed} z {count}',
  'inbox.uploadPaymentConfirm': 'Prześlij ({count})',
  'inbox.uploadPaymentReceipt': 'Dokument',
  'inbox.cardNudgeTitle': 'Dokumenty bez źródła płatności: {count}',
  'inbox.cardNudgeText': 'Zarejestruj karty przy rachunkach bankowych, a Plumme rozpozna płatność bezpośrednio z paragonu. Typ rachunku decyduje, czy zakup jest firmowy, czy jest wydatkiem prywatnym.',
  'inbox.cardNudgeAction': 'Zarejestruj karty',
  'inbox.shortDescription': 'Krótki opis dokumentu',
  'inbox.shrinkPreview': 'Zmniejsz podgląd',
  'inbox.growPreview': 'Powiększ podgląd',
  'inbox.dragWidth': 'Przeciągnij, aby zmienić szerokość',
  'inbox.sendTo': 'Wyślij do:',
  'inbox.filterStatus': 'Status',
  'inbox.filterBankConnection': 'Połączenie z bankiem',
  'inbox.filterReadyToPost': 'Gotowe do zaksięgowania',
  'inbox.filterNeedsReview': 'Do sprawdzenia',
  'inbox.filterAwaitingAnalysis': 'Czeka na analizę',
  'inbox.toInbox': 'Do skrzynki odbiorczej (dokumenty)',
  'inbox.toDocumentation': 'Do dokumentacji',
  'inbox.selectAll': 'Zaznacz wszystkie',
  'inbox.selectHint': 'Shift+klik, aby zaznaczyć zakres',
  'inbox.reviewSelected': 'Rozpocznij księgowanie ({count})',
  'inbox.planTitle': 'Księguj z SuperPlumma',
  'inbox.planLead': 'Teraz zostanie zaksięgowanych {count} z {selected} wybranych dokumentów.',
  'inbox.planNothing': 'Żadnego z wybranych dokumentów nie można zaksięgować w obecnej postaci.',
  'inbox.planWithNotes': 'Ze wstępnie wybranym źródłem płatności: {count}',
  'inbox.planConfirm': 'Zaksięguj dokumenty ({count})',
  'inbox.planShow': 'Pokaż',
  'inbox.planHide': 'Ukryj',
  'inbox.planSameFile': 'Zablokowane: dokładnie ten sam plik już istnieje ({count})',
  'inbox.planSameInvoiceNumber': 'Zablokowane: numer faktury jest już zarejestrowany ({count})',
  'inbox.planSameContent': 'Pominięte: możliwe podwójne przesłanie ({count})',
  'inbox.planNeedsReview': 'Pominięte: wymaga sprawdzenia ({count})',
  'inbox.planMissingData': 'Pominięte: brak danych ({count})',
  'inbox.planMissing': 'Pominięte: już nie istnieje ({count})',
  'inbox.planAllowContent': 'Zaksięguj mimo to - sprawdziłem, że to różne zakupy',
  'inbox.planAllowContentWarn': 'Duplikaty zostaną zaksięgowane jako osobne dokumenty. Sprawdź, czy to się zgadza, zanim przejdziesz dalej.',
  'inbox.planResultTitle': 'Księgowanie zakończone',
  'inbox.planResultLead': 'Zaksięgowano {booked} z {selected} wybranych dokumentów.',
  'inbox.planBooked': 'Zaksięgowane ({count})',
  'inbox.planSkipped': 'Pominięte ({count})',
  'inbox.planFailed': 'Nieudane ({count})',
  'inbox.walkTitle': 'Księgowanie dokumentów',
  'inbox.walkLead': 'Dokumenty w kolejce: {count}.',
  'inbox.walkReady': 'Gotowe',
  'inbox.walkNeedsReview': 'Wymaga kontroli',
  'inbox.walkDuplicates': 'Możliwe duplikaty',
  'inbox.walkDuplicateOf': 'To samo co {names}.',
  'inbox.walkHint': 'Możesz zamknąć w dowolnym momencie - nieobsłużone dokumenty pozostaną zaznaczone.',
  'inbox.walkStart': 'Przejrzyj wszystkie ({count})',
  'inbox.walkBookReady': 'Zaksięguj teraz gotowe ({count})',
  'inbox.walkPosition': '{index} z {total}',
  'inbox.walkPause': 'Kontynuuj później',
  'inbox.walkTrash': 'Do kosza',
  'inbox.walkSkip': 'Pomiń',
  'inbox.walkNext': 'Dalej',
  'inbox.walkGone': 'Dokument zniknął',
  'inbox.walkGoneText': 'Został zaksięgowany, usunięty lub przeniesiony, gdy przegląd był otwarty.',
  'inbox.walkDoneTitle': 'Przegląd zakończony',
  'inbox.walkDoneLead': 'Przejrzane dokumenty: {count}',
  'inbox.walkDoneCounts': 'Zaksięgowane: {booked}, pominięte: {skipped}, przeniesione do kosza: {trashed}.',
  'inbox.clearSelection': 'Wyczyść zaznaczenie',
  'inbox.restoreAll': 'Przywróć wszystkie',
  'inbox.deletePermanently': 'Usuń trwale',
  'inbox.deleteAll': 'Usuń wszystkie',
  'inbox.downloadAll': 'Pobierz wybrane',
  'inbox.downloading': 'Pobieranie...',
  'inbox.postAllWithAi': 'Zaksięguj wszystkie z SuperPlumma',
  'inbox.postWithAi': 'Zaksięguj z SuperPlumma ({count})',
  'inbox.postNoneReady': 'Żaden z wybranych dokumentów nie jest gotowy do zaksięgowania. Użyj „Rozpocznij księgowanie”, aby obsłużyć je po kolei.',
  'inbox.uploadDocument': 'Prześlij dokument',
  'inbox.mergeToOne': 'Scal w jeden dokument',
  'inbox.dragToMerge': 'Przeciągnij, aby scalić dokumenty',
  'inbox.restore': 'Przywróć',
  'inbox.post': 'Zaksięguj',
  'inbox.archiveNote': 'Archiwum dokumentów, które nie mają być księgowane jako dowody księgowe.',
  'inbox.searchDocs': 'Szukaj w dokumentach...',
  'inbox.moveToTrash': 'Przenieś do kosza',
  'inbox.defaultVoucherName': 'Dokument',
  'inbox.defaultDocumentName': 'Dokument',
  'inbox.docTypeSettlement': 'Rozliczenie',
  'inbox.docTypeSupplierInvoice': 'Faktura od dostawcy',
  'inbox.docTypeSaleVoucher': 'Dowód sprzedaży',
  'inbox.docTypePurchaseVoucher': 'Dowód zakupu',
  'inbox.paySourcePrivate': 'Zapłacone prywatnie',
  'inbox.paySourceCash': 'Gotówka',
  'inbox.paySourceUnclear': 'Niewyjaśniona płatność',
  'inbox.paySourceCompany': 'Konto firmowe',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % VAT na dokumencie · {deductionRate} % odliczenia',
  'inbox.vatRateLabel': '{rate} % VAT',
  'inbox.paidFromBank': 'Zapłacone z banku',
  'inbox.supplierNotRead': 'Nie odczytano firmy',
  'inbox.invoiceNumberLabel': 'Faktura {number}',
  'inbox.attachmentLinkMissing': 'Załącznik nie ma dostępnego linku.',
  'inbox.menuNewPurchase': 'Opłacony zakup',
  'inbox.menuFixedAsset': 'Środek trwały',
  'inbox.menuOtherSale': 'Inna sprzedaż',
  'inbox.menuOpenAttachment': 'Otwórz załącznik',
  'inbox.menuDownload': 'Pobierz',
  'inbox.menuSplitAgain': 'Podziel ponownie',
  'inbox.reanalyze': 'Analizuj ponownie',
  'inbox.analyze': 'Analizuj',
  'inbox.previewDocumentFallback': 'Dokument',
  'inbox.previewMissingFileLink': 'Brak linku do pliku',
  'inbox.saveNotConnected': 'Zapisywanie propozycji dokumentu nie jest połączone z backendem.',
  'inbox.suggestionUpdated': 'Propozycja dokumentu została zaktualizowana.',
  'inbox.suggestionSaveFailed': 'Nie udało się zapisać propozycji dokumentu.',
  'inbox.settlementFromLabel': 'Rozliczenie od',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'ID rozliczenia',
  'inbox.settlementNetToBankLabel': 'Netto na konto',
  'inbox.suggestedInvoiceSingular': 'Proponowana faktura',
  'inbox.suggestedInvoicePlural': 'Kilka możliwych faktur',
  'inbox.selectInvoiceManually': 'Wybierz fakturę ręcznie',
  'inbox.paidToggleOn': 'Zapłacone',
  'inbox.paidToggleOff': 'Niezapłacone – ujmowane jako zobowiązanie wobec dostawcy',
  'inbox.paidToLabel': 'Zapłacono do',
  'inbox.projectSaveFailed': 'Nie udało się zapisać projektu.',
  'inbox.awaitingOcrData': 'Oczekiwanie na dane OCR',
  'inbox.showSuggestionAgain': 'Pokaż propozycję ponownie',
  'inbox.maximizePreview': 'Maksymalizuj podgląd',
  'inbox.uploadPartialAnalyzing': 'Przesłano {done} z {total} dokumentów. Analizuję te, które dotarły ...',
  'inbox.uploadedSingle': 'Dokument przesłany.',
  'inbox.uploadedMultipleAnalyzing': 'Przesłane dokumenty: {count}. Analizuję ...',
  'inbox.uploadFailedSingle': 'Nie udało się przesłać dokumentu.',
  'inbox.uploadFailedMultiple': 'Nie udało się przesłać dokumentów.',
  'inbox.uploadFailedGeneric': 'Nie udało się przesłać dokumentów.',
  'inbox.remainingAwaitingAnalysisSuffix': 'Dokumenty pozostające jako „Oczekuje na analizę”: {count}.',
  'inbox.uploadedButAnalysisFailedSingle': 'Dokument został przesłany, ale analiza się nie powiodła.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Dokumenty zostały przesłane, ale analiza się nie powiodła.',
  'inbox.partialAnalysisFailed': 'Nie przeanalizowano {failed} z {total} dokumentów. Spróbuj „Analizuj” w wierszu.',
  'inbox.documentAddedSingle': 'Dokument dodano do Dokumentacji.',
  'inbox.documentAddedMultiple': 'Dokumenty dodano do Dokumentacji.',
  'inbox.documentUploadFailed': 'Nie udało się przesłać dokumentu.',
  'inbox.analyzed': 'Dokument został przeanalizowany.',
  'inbox.analyzeActionFailed': 'Analiza dokumentu się nie powiodła.',
  'inbox.bookedNoneReason': 'Nie zaksięgowano żadnych dokumentów.',
  'inbox.bookedSummary': 'Zaksięgowane: {booked}, pominięte: {skipped}.',
  'inbox.bookedOne': 'Dokument został zaksięgowany.',
  'inbox.bookedCount': 'Zaksięgowane dokumenty: {count}.',
  'inbox.bookFailedFallback': 'Nie udało się zaksięgować dokumentów.',
  'inbox.setPaymentSourceFailed': 'Nie udało się ustawić źródła płatności.',
  'inbox.moveToTrashFailed': 'Nie udało się przenieść dokumentu.',
  'inbox.movedToTrash': 'Dokument przeniesiono do kosza.',
  'inbox.movedToTrashCount': 'Dokumenty przeniesione do kosza: {count}.',
  'inbox.restoredOne': 'Dokument przywrócony.',
  'inbox.restoredCount': 'Przywrócone dokumenty: {count}.',
  'inbox.restoreFailed': 'Nie udało się przywrócić dokumentu.',
  'inbox.confirmDeletePermanentOne': 'Usunąć dokument trwale?',
  'inbox.confirmDeletePermanentMany': 'Usunąć wybrane dokumenty trwale?',
  'inbox.deletedPermanently': 'Dokument usunięty trwale.',
  'inbox.deleteFailed': 'Nie udało się usunąć dokumentu.',
  'inbox.docMovedToTrash': 'Dokument przeniesiono do kosza.',
  'inbox.docMovedToTrashCount': 'Dokumenty przeniesione do kosza: {count}.',
  'inbox.docMoveToTrashFailed': 'Nie udało się przenieść dokumentu.',
  'inbox.docRestored': 'Dokument przywrócony.',
  'inbox.docRestoredCount': 'Przywrócone dokumenty: {count}.',
  'inbox.docRestoreFailed': 'Nie udało się przywrócić dokumentu.',
  'inbox.confirmDeleteDocOne': 'Usunąć dokument trwale?',
  'inbox.confirmDeleteDocMany': 'Usunąć wybrane dokumenty trwale?',
  'inbox.docDeletedPermanently': 'Dokument usunięty trwale.',
  'inbox.docDeleteFailed': 'Nie udało się usunąć dokumentu.',
  'inbox.downloadPartial': 'Pobrano {downloaded} z {total} plików. Pozostałych nie udało się pobrać.',
  'inbox.downloadedZip': 'Pliki pobrane jako zip: {count}.',
  'inbox.downloadedSingleFile': 'Plik został pobrany.',
  'inbox.downloadFilesFailed': 'Nie udało się pobrać plików.',
  'inbox.movedToDocs': 'Dokument przeniesiono do Dokumentacji.',
  'inbox.movedToDocsCount': 'Dokumenty przeniesione do Dokumentacji: {count}.',
  'inbox.moveToDocsFailed': 'Nie udało się przenieść dokumentu do Dokumentacji.',
  'inbox.mergedCount': 'Scalone dokumenty: {count}.',
  'inbox.mergeFailed': 'Nie udało się scalić dokumentów.',
  'inbox.splitAgainDone': 'Dokument został ponownie podzielony.',
  'inbox.splitAgainFailed': 'Nie udało się podzielić dokumentu.',
  'inbox.addressCopied': 'Skopiowano adres do dokumentów.',
  'inbox.trashTitle': 'Kosz',
  'inbox.docsSubtitle': 'Archiwum umów, kontraktów i dokumentów - nie dowodów księgowych do zaksięgowania.',
  'inbox.inboxSubtitle': 'Prześlij dokumenty lub przekaż je e-mailem - odczytamy, co się da.',
  'inbox.titleHelp': 'Skrzynka odbiorcza to miejsce na dokumenty, które dotarły, ale nie zostały jeszcze zaksięgowane. Prześlij pliki lub przekaż paragony i faktury e-mailem - SuperPlumma odczyta treść i przygotuje je do zaksięgowania.',
  'inbox.docsWithCount': 'Dokumentacja ({count})',
  'inbox.trashWithCount': 'Kosz ({count})',
});
